// Angular
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
// RxJS
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { LoaderService } from '../../layout/services/loader.service';
import { AuthService } from '../../../../core/auth/_services/auth.service';

/**
 * More information there => https://medium.com/@MetonymyQT/angular-http-interceptors-what-are-they-and-how-to-use-them-52e060321088
 */
@Injectable()
export class InterceptService {
	// intercept request and add token
	constructor(public loaderService: LoaderService,
		public authService:AuthService
		) {}
	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		this.loaderService.display(true);
		if(request.body instanceof FormData){
			request = request.clone({
				setHeaders: {
					'Authorization': 'Bearer '+localStorage.getItem(environment.authTokenKey)
				}
			});
		} else {
			if(localStorage.getItem(environment.authTokenKey) && localStorage.getItem(environment.authTokenKey) !== null && localStorage.getItem(environment.authTokenKey) !== undefined){
				request = request.clone({
					setHeaders: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer '+localStorage.getItem(environment.authTokenKey)
					}
				});
			} else {
				request = request.clone({
					setHeaders: {
						'Content-Type': 'application/json',
					}
				});
			}
		}

		return next.handle(request).pipe(
			tap(
				event => {
					 if (event instanceof HttpResponse) {
						this.loaderService.display(false);
					}
				},
				error => {					
					this.loaderService.display(false);
					console.error(error);
					console.error(error.status);
					if(error.status_code=='403' || error.status=='401'){
                        //    this.authService.logout();
					}
					console.error(error.message);
				}
			)
		);
	}
}
